$(document).ready(function(){
  if($('.custom__hero_slideshow_wrapper').length > 0){
    var arrow = $('.custom__hero_slideshow_wrapper').attr("data-arrow") == 'false' ? false : true,
      autoplay = $('.custom__hero_slideshow_wrapper').attr("data-autoplay") == 'false' ? false : true,
       infinite = $('.custom__hero_slideshow_wrapper').attr("data-infinite") == 'false' ? false : true;
    $('.custom__hero_slideshow_wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
      dots: false,
      fade: true,
      arrows: arrow,
      prevArrow: $('.slider_arrow').find('.prev'),
      nextArrow: $('.slider_arrow').find('.next'),
      centerMode: true,
      focusOnSelect: true,
      adaptiveHeight: false,
      lazyLoad: 'ondemand', 
      autoplay: autoplay,
      autoplaySpeed: parseInt($('.custom__hero_slideshow_wrapper').attr("data-autoplay_speed")),
      infinite: infinite,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            asNavFor: '.custom_icons_positin .icons_flex'
          }
        }
      ]
    });
    
  
        var slick_settings = {
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: '.custom__hero_slideshow_wrapper',
          speed: 500,
          dots: false,
          arrows: arrow,
          centerMode: false,
          adaptiveHeight: false,
          autoplay: autoplay,
          autoplaySpeed: parseInt($('.custom__hero_slideshow_wrapper').attr("data-autoplay_speed")),
          infinite: infinite,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false
              }
            }
          ]
        };
         if($(window).width() <= 768){
          $('.custom_hero_banner').find(".icons_flex").slick(slick_settings);
         }
        $(window).on("resize orientationchange load", function(event) {
             if($(window).width() > 768 &&  $('.custom_hero_banner').find(".icons_flex").hasClass("slick-initialized")){
               $('.custom_hero_banner').find(".icons_flex").slick("unslick");
             } else if($(window).width() <= 768){
               if(!$('.custom_hero_banner').find(".icons_flex").hasClass("slick-initialized")){
                 $('.custom_hero_banner').find(".icons_flex").not(".slick-initialized").slick(slick_settings);
               } else if(event.type != 'load'){
                $('.custom_hero_banner').find(".icons_flex").slick("refresh");
               }
               
             }
        });


    $('.custom__hero_slideshow_wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide){
      $('.icons_wrp').removeClass("active_hover");
      if($('.icons_wrp[data-index="'+currentSlide+'"]').length > 0){
        $('.icons_wrp[data-index="'+currentSlide+'"]').addClass("active_hover");
      }
    });

    $('body').on("click","div.icons_wrp",function(e){
      e.preventDefault();
      var index = parseInt($(this).attr("data-index"));
      $('.custom__hero_slideshow_wrapper').slick('slickGoTo', index);
      
      if($(window).width() <= 989){
        setTimeout(function(){
          $("html, body").animate({ scrollTop: 0 }, "slow");
        },600);
      }
    });

    // if(!$('body').hasClass('template-index') && ($('body').hasClass('template-page-about-us') || $('body').hasClass('template-page-contact'))){
    //   var height = $('.custom_header').outerHeight();
    //   $('.custom_hero___img_wrp').css("padding-top","calc(100vh - "+height+"px)");
    // } 
    
      if($('.announcement-bar-section').length > 0){
        $('.custom__hero_slideshow_wrapper').css("--minus_height",$('.announcement-bar-section').outerHeight()+"px");
      }
    
    
  }
});